import { VFC, FC } from "react";

import { FormControl, RadioGroup, FormControlLabel, Radio } from "@portex-pro/ui-components";
import PortexDialog from "components/PortexDialog";
import SelectDateView from "components/SelectDateView";
import Text from "components/Text";
import { useTranslation } from "react-i18next";

const FilterRow: FC<{ name: string }> = ({ name, children }) => {
  return (
    <div className="flex w-full items-center space-y-2">
      <div className="w-1/2">
        <Text size="small" weight="bold">
          {name}
        </Text>
      </div>
      <div className="w-full">{children}</div>
    </div>
  );
};

interface ShipperLoadsIndexFiltersDialogViewProps {
  isOpen: boolean;
  onClose: () => void;
  onChangePickup: ({ from, to }: { from: string | undefined; to: string | undefined }) => void;
  onChangeDelivery: ({ from, to }: { from: string | undefined; to: string | undefined }) => void;
  pickupFrom: string | undefined;
  pickupTo: string | undefined;
  deliveryFrom: string | undefined;
  deliveryTo: string | undefined;
  ownersSearch: JSX.Element;
  onlyUnseenNotifications: boolean;
  onChangeOnlyUnseenNotifications: (value: boolean) => void;
}

const ShipperLoadsIndexFiltersDialogView: VFC<ShipperLoadsIndexFiltersDialogViewProps> = ({
  isOpen,
  onClose,
  onChangePickup,
  onChangeDelivery,
  pickupFrom,
  pickupTo,
  deliveryFrom,
  deliveryTo,
  ownersSearch,
  onlyUnseenNotifications,
  onChangeOnlyUnseenNotifications,
}) => {
  const { t } = useTranslation("loadsIndex");

  return (
    <PortexDialog
      open={isOpen}
      onClose={onClose}
      title={t("filters_dialog_title")}
      confirmButtonCopy={t("filters_dialog_confirm")}
      onClickConfirm={onClose}
      maxWidth="md"
    >
      <div className="flex flex-col my-5 mx-8 space-y-4">
        <FilterRow name={t("filters_dialog_pickup")}>
          <SelectDateView
            from={pickupFrom}
            to={pickupTo}
            onChange={onChangePickup}
            divProps={{ className: "w-full" }}
          />
        </FilterRow>
        <FilterRow name={t("filters_dialog_delivery")}>
          <SelectDateView
            from={deliveryFrom}
            to={deliveryTo}
            onChange={onChangeDelivery}
            divProps={{ className: "w-full" }}
          />
        </FilterRow>
        <FilterRow name={t("filters_dialog_owner")}>{ownersSearch}</FilterRow>
        <FilterRow name={t("filters_dialog_notification_name")}>
          <FormControl style={{ display: "flex", flexDirection: "row" }}>
            <RadioGroup value={onlyUnseenNotifications} style={{ display: "flex", flexDirection: "row" }}>
              <FormControlLabel
                value={false}
                label={t("filters_dialog_notification_all")}
                control={<Radio onClick={() => onChangeOnlyUnseenNotifications(false)} />}
              />
              <FormControlLabel
                value={true}
                label={t("filters_dialog_notification_unread")}
                control={<Radio onClick={() => onChangeOnlyUnseenNotifications(true)} />}
              />
            </RadioGroup>
          </FormControl>
        </FilterRow>
      </div>
    </PortexDialog>
  );
};

export default ShipperLoadsIndexFiltersDialogView;
